@if ({activeUser: activeUser$ | async}; as state) {
  <cs-shared-header
    [label]="challenge()?.label"
    [tabs]="tabs"
    [selectedTab]="selectedView()"
    (backClick)="onBackClick()"
    (tabChange)="onViewChange($event)"
  >
    <div slot="header-right" class="coin-display">
      <span>{{ state.activeUser?.systemCoins | numberAbbreviation }}</span>
      <mat-icon svgIcon="coin-golden"></mat-icon>
    </div>
  </cs-shared-header>

  @if (challengeLoading()) {
    <div class="loading-container">
      <oph-loading></oph-loading>
    </div>
  } @else {
    <div class="tab-content-wrapper" [@tabContentSlide]="selectedViewIndex()">
      @if (selectedView() === 'tasks') {
        <div class="sked-list-container">
          <cs-challenges-tasks
            [initialDay]="persistedDay()"
            (selectedDayChange)="persistedDay.set($event)"
          ></cs-challenges-tasks>
        </div>
      } @else {
        <div class="sked-list-container">
          <cs-challenges-cycles
            [initialCycleKey]="persistedCycleKey()"
            (selectedCycleKeyChange)="persistedCycleKey.set($event)"
          ></cs-challenges-cycles>
        </div>
      }
    </div>
  }
}
